import { render, staticRenderFns } from "./SplitterModalSelectDestination.vue?vue&type=template&id=72e80a68"
import script from "./SplitterModalSelectDestination.vue?vue&type=script&lang=js"
export * from "./SplitterModalSelectDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports